var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.comprobantes, function(comprobante, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(comprobante.descripcion_tipo_programacion)
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.numero_documento))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.fecha_emision))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.nombre_cliente))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.valor_iva))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(comprobante.valor_total))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-success btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.clonar(comprobante.id_comprobante)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-clone" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger btn--text",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.anular(comprobante.id_comprobante)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-calendar" })]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.comprobantes.length === 0,
                          expression: "comprobantes.length === 0"
                        }
                      ]
                    },
                    [_vm._m(2)]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Lista de facturas programadas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tipo de programación")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Documento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("IVA")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("strong", [_vm._v("No hay comprobantes programados.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00348a38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00348a38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ListaFacturasProgramadas.vue
// module id = 475
// module chunks = 0